import { Box, ErrorBoundary } from '@genial/components';
import { RouteProp, useRoute } from '@react-navigation/native';
import React, { useEffect } from 'react';

import { SignedOutRootStackParamList } from '../../routes/types';
import { useFixedFeeTermAcceptanceLinkActions } from '../../store/fixedFeeTermAcceptanceLink/action';

import { TermFlow } from './components/TermFlow';
import { ValidateToken } from './components/ValidateToken';
import { expiredLinkMessage } from './constants';
import { useAuthenticationTerm } from './hooks/useAuthenticationTerm';

export const FixedFeeTermAcceptanceLink = () => {
  const route = useRoute<RouteProp<SignedOutRootStackParamList, 'FixedFeeTermAcceptanceLink'>>();
  const urlParams = new URLSearchParams(window.location.search);
  const termId = urlParams.get('termId') || route.params?.termId || '';

  const { addTermId } = useFixedFeeTermAcceptanceLinkActions();
  const {
    isValidatedToken,
    errorValidateToken,
    handleValidateToken,
    loadingToken,
    isExpiredToken,
  } = useAuthenticationTerm();

  useEffect(() => {
    if (termId) {
      addTermId(termId);
    }
  }, [addTermId, termId]);

  if (isExpiredToken) {
    return (
      <Box px="inline.xxs" paddingTop="stack.xxxl">
        <ErrorBoundary
          errorIconOrIllustration="WarningIllustration"
          errorTitle={expiredLinkMessage.title}
          errorMessage={expiredLinkMessage.message}
        />
      </Box>
    );
  }

  return isValidatedToken ? (
    <TermFlow />
  ) : (
    <ValidateToken
      errorValidateToken={errorValidateToken}
      handleValidateToken={handleValidateToken}
      loadingToken={loadingToken}
    />
  );
};
